import { type LibraryWithPermissions } from '@air/api/types';

import { type RearrangableItem } from '~/components/Shared/Drag/dragTypes';

export type CalculateLibraryRearrangeDataResult = {
  newIndex: number;
  nextItemId: string | null;
  previousItemId: string | null;
};

export const calculateLibraryRearrangeData = (
  libraries: LibraryWithPermissions[],
  draggedLibrary: LibraryWithPermissions,
  adjacentItem: RearrangableItem,
): CalculateLibraryRearrangeDataResult => {
  const { direction, index } = adjacentItem;
  const newIndex = direction === 'after' ? index + 1 : index;

  // Calculate the IDs of adjacent libraries after the move
  let nextItemId: string | null = null;
  let previousItemId: string | null = null;

  if (direction === 'after') {
    previousItemId = libraries[index]?.id ?? null;
    nextItemId = libraries[index + 1]?.id ?? null;
  } else {
    previousItemId = index > 0 ? (libraries[index - 1]?.id ?? null) : null;
    nextItemId = libraries[index]?.id ?? null;
  }

  // If we're dropping on the same item, adjust the IDs to skip the dragged item
  if (nextItemId === draggedLibrary.id) {
    nextItemId = libraries[newIndex + 1]?.id ?? null;
  }
  if (previousItemId === draggedLibrary.id) {
    previousItemId = newIndex > 0 ? (libraries[newIndex - 1]?.id ?? null) : null;
  }

  return { newIndex, nextItemId, previousItemId };
};
